"use strict";

var impersonationControllers = angular.module("controllers.impersonation", []);


impersonationControllers.controller("impersonationCtrl", ['$scope', '$q', '$translate', '$rootScope', '$location', '$interval', '$log', 'serviceRequestService', 'filterFilter', 'localStorageService', 'storageKeys', 'storeService', 'appSettings', '$sce', 'surveyService', 'clockService', 'Notification', 'sseService','gfOIDCService','$timeout', 'impersonationService','userService','$window',
    function ($scope, $q, $translate, $rootScope, $location, $interval, $log, serviceRequestService, filterFilter, localStorageService, storageKeys, storeService, appSettings, $sce, surveyService, clockService, Notification, sseService, gfOIDCService, $timeout, impersonationService,userService, $window) {

        $scope.screenToDisplay = "";
        $scope.formDisabled = false;
        $scope.loginPanelVisible = false;
        $scope.users = [];
        $scope.showInvalidUsername = false;
        $scope.alreadyLoggedIn = false;

        $scope.storeCredentials = {
            macDonaldsId: "",
            password: ""
        };

        $scope.credentials ={
            username:"",
            password:""
        };

        $scope.userTypeError = false;

        $scope.step=0;

        $scope.isAllowedToImpersonate = impersonationService.allowedImpersonation;

        var hasProfile = localStorageService.get(storageKeys.profileKey);
        var impersonatedMode = impersonationService.isImpersonationMode();
        if (impersonatedMode) {
            $location.path('/impersonate');
            $scope.userTypeError = !($scope.isAllowedToImpersonate() && (hasProfile !== null || hasProfile !== undefined) );
        }
        else{
            $location.path('/service-request-list');
        }

        $scope.goBack = function(view){
            if(view ==='storeLogin'){
                $scope.panelToDisplay = view
                $scope.step = 1;
            }else {
                $scope.step = 0;
            }
        };

        $scope.panelToDisplay = "storeLogin";
        $scope.loginPanelVisible = false;
        $scope.adminLoginPanelVisible = false;

        $scope.showSignin = function(mode){
            if(mode === appSettings.storeLoginType){
                $scope.panelToDisplay = "storeLogin";
                $scope.screenToDisplay = 'STORE'
            }else if(mode === appSettings.engineerRole){
                $scope.screenToDisplay = 'ENGINEER'
                $scope.panelToDisplay = "engineerLogin";
            }
            $scope.step=1;
            $scope.loginPanelVisible = true;
        };

        $scope.setUser = function (id, username) {
            $scope.showChangePasswordRequestSuccessful = false;
            $scope.selectedUser = id;
            $scope.credentials.username = username;
            $scope.credentials.password = "";
        };

        $scope.impersonate = function(username){
            gfOIDCService.impersonate(username);
        };

        $scope.exitImpersonation = function(){
            gfOIDCService.impersonate();
        };

        $scope.validateStore = function () {
            $scope.selectedUser = 0;
            disableForm();

            $scope.storeCredentials.password = $scope.storeCredentials.macDonaldsId;

            storeService.authenticateImpersonatedUser($scope.storeCredentials).then(
                function (storeResource) {

                    storeService.setStoreContext(storeResource);

                    $rootScope.$broadcast('setStore',storeResource);
                    $rootScope.$broadcast('setStoreTime',storeResource);

                    storeResource.$get("users").then(function (resource) {
                        if(resource.$has("userList")) {
                            resource.$get("userList").then(function (list) {
                                $scope.error = false;
                                $scope.noStoreUsers = false;
                                $scope.users = list;
                                impersonationService.setStoreUsers(list);
                                $scope.panelToDisplay = "userLogin";
                                $timeout(enableForm, 0);
                                $scope.step=2;
                            });
                        }else{
                            $scope.error = true;
                            $scope.noStoreUsers = true;
                            storeService.removeStoreContext();
                            $timeout(enableForm, 0);
                        }
                    });
                },
                function (status) {
                    $scope.error = true;
                    $scope.noStoreUsers = false;
                    $timeout(enableForm, 2500);
                }
            );
        };

        function validateEngineer() {
            $scope.showInvalidUsername = true;
            $timeout(enableForm, 0);
        }

        function renewToken(){
            gfOIDCService.getNewToken($scope.credentials.username);
        }

        $scope.login = function (mode,username) {
            $scope.error = false
            $scope.formDisabled = true
            $log.debug("mode "+mode );
            if (mode === appSettings.storeLoginType) {
                $log.debug("store mode");
                localStorageService.set(storageKeys.loginTypeKey, appSettings.storeLoginType);
                gfOIDCService.impersonate($scope.credentials.username);
            } else if (mode === appSettings.engineerRole) {
                $log.debug("engineer mode");
                disableForm();
                localStorageService.set(storageKeys.loginTypeKey, appSettings.engineerRole);
                if(($scope.credentials.username == null || $scope.credentials.username == "")){
                    return validateEngineer();
                }
                userService.exists($scope.credentials.username).then(function(response){
                    console.log(response);
                    if(response !== null){
                        gfOIDCService.impersonate($scope.credentials.username);
                    }else{
                        return validateEngineer();
                    }
                });
            }else if(mode===appSettings.impersonationLoginType){
                if(username){
                    gfOIDCService.signinRedirect(username);
                }else{
                    gfOIDCService.signinRedirect();
                }
            } else {
                $log.debug("gonna logout");
                //sseService.delete();              //commented it to test ES-4878
                gfOIDCService.logout();
                $scope.errorHeadder = "Warning";
                $scope.error = true;
                $scope.errorMessage = $translate.instant('label.controller.services.loginController.NotAuthorised');
                $scope.errorType =  "alert-warning";
                $timeout(enableForm, 2500);
            }

            // Delay this call by one second to address firefox race condition issue on JS
            setTimeout(renewToken,1000);
        }

        var enableForm = function() {
            $scope.formDisabled = false;
        };
        var disableForm = function() {
            $scope.formDisabled = true;
        };

        $scope.initImpersonation =function (username){
            $log.debug("Trying to initiate impersonation mode");
            var profile = localStorageService.get(storageKeys.profileKey);
            var loginType = localStorageService.get(storageKeys.loginTypeKey);
            if(profile && (loginType === 'ENGINEER' || loginType === 'STORE') ){
                $log.debug("Found user login so aborting impersonation initiation!");
                $scope.alreadyLoggedIn = true;
                return;
            }
            if(profile && loginType === 'IMPERSONATE' ){
                $log.debug("Found user impersonating in local storage. Aborting impersonation initiation!");
                $scope.alreadyLoggedIn = true;
                return;
            }

            localStorageService.set(storageKeys.loginTypeKey, appSettings.impersonationLoginType);
            $log.debug("username "+username);
            $scope.alreadyLoggedIn = false;
            gfOIDCService.signinRedirect(username);
        }

        $scope.clearAll = function(username){
            sseService.delete();
            localStorageService.clearAll();
            var window = $window.open(impersonationService.ssoLogoutURI); // For local/dev env change this to https://hki-auth.dev.local/auth/logout
            setTimeout(function(){
                window.close();
                $scope.takeToImpersonation(username);
            },1500);
        };

        
        $scope.takeToImpersonation = function(username){
            $window.location.href = impersonationService.impersonationHomeURI
            + username.length>0 ? "?j_username=" + username
                : "";
        }

        var storeUsersCopy = impersonationService.getStoreUsers();
        if(storeUsersCopy && storeUsersCopy.length >0){
            $scope.users = Array.from(storeUsersCopy);
        }

        var storeData = localStorageService.get(storageKeys.storeKey);
        if(storeData){
            $scope.step = 2;
            $scope.panelToDisplay = "userLogin"
            $scope.loginPanelVisible = true;
            $scope.screenToDisplay = "STORE";
        }

    }]);